import { IncidentFilterMeta } from '@src/main/modules/other_incidents/ui/hooks/mapIncidentFiltersToCriteria';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { useMemo } from 'react';

export const useIncidentFilters = (startDate: Date | null, endDate: Date | null) =>
  useMemo<IncidentFilterMeta>(
    () => ({
      global: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      },

      flightDate: {
        operator: FilterOperator.AND,
        constraints: [
          {
            value: [startDate ? new Date(startDate) : null, endDate ? new Date(endDate) : null],
            matchMode: FilterMatchMode.BETWEEN,
          },
        ],
      },
      incidentDate: {
        operator: FilterOperator.AND,
        constraints: [
          {
            value: [null, null],
            matchMode: FilterMatchMode.BETWEEN,
          },
        ],
      },
      updatedAt: {
        operator: FilterOperator.AND,
        constraints: [
          {
            value: [null, null],
            matchMode: FilterMatchMode.BETWEEN,
          },
        ],
      },

      flightNumber: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      departure: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      arrival: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      employeeId: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      appVersion: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      state: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      comment: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      idEmployeeAnswered: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      linkColumbus: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    }),
    [startDate, endDate],
  );
